export default __webpack_public_path__ + "static/media/mn_tea_sub_5.5dab66b9.png";